import { render, staticRenderFns } from "./ImportInvoiceAsTrips.vue?vue&type=template&id=38b7c8e2&scoped=true&"
import script from "./ImportInvoiceAsTrips.vue?vue&type=script&lang=js&"
export * from "./ImportInvoiceAsTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7c8e2",
  null
  
)

export default component.exports